/**
 * Configuration file for controlling feature visibility on various pages
 */

interface PageFeaturesConfig {
  showTestimonials: boolean;
  // Add other feature flags as needed
}

type PageConfigMap = {
  [key: string]: PageFeaturesConfig;
};

/**
 * Configuration for controlling which features are visible on each page
 */
const pageFeaturesConfig: PageConfigMap = {
  // Service pages
  agents: {
    showTestimonials: true,
  },
  ads: {
    showTestimonials: false, // Hide testimonials on ads page
  },
  webdesign: {
    showTestimonials: true,
  },
  automation: {
    showTestimonials: true,
  },

  // Add more pages as needed
  home: {
    showTestimonials: true,
  },
};

/**
 * Get configuration for a specific page
 * @param pageName The name/key of the page to get configuration for
 * @returns The page configuration or a default configuration if not found
 */
export const getPageConfig = (pageName: string): PageFeaturesConfig => {
  return pageFeaturesConfig[pageName] || { showTestimonials: true };
};

export default pageFeaturesConfig;
